export const HOWARD_SUBCATEGORY_KEY   = "howardstern";
export const HOWARD_SUPERCATEGORY_KEY = "howard";
